import { render, staticRenderFns } from "./chatSelectBar.vue?vue&type=template&id=5da21bd2&scoped=true"
import script from "./chatSelectBar.vue?vue&type=script&lang=js"
export * from "./chatSelectBar.vue?vue&type=script&lang=js"
import style0 from "./chatSelectBar.vue?vue&type=style&index=0&id=5da21bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da21bd2",
  null
  
)

export default component.exports